import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  createPaidOut,
  fetchPaidOuts,
  type CreatePaidOutPayload,
  type ListPaidOutsQuery,
} from '@/services/api/retailPaidOuts.api';

export function useRetailPaidOuts(query: ListPaidOutsQuery, enabled = true) {
  return useQuery({
    queryKey: ['retail-paid-outs', query],
    queryFn: () => fetchPaidOuts(query),
    staleTime: 30_000,
    enabled: enabled && !!query.propertyId,
  });
}

export function useCreateRetailPaidOut() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: CreatePaidOutPayload) => createPaidOut(payload),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['retail-paid-outs'] });
      void queryClient.invalidateQueries({ queryKey: ['retail-reports', 'activity'] });
    },
  });
}
